module.exports = __webpack_public_path__ + "img/icons BFr_28.e58c46d3.svg";